import React from 'react';
import { shape, string } from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';

import Css from './Desktop.scss';
import ImportImages from '@src/importImages';

const cockpitEmpty = ImportImages('/safety/cockpit-empty.jpg');
const clouds = ImportImages('/home/clouds.jpg');

const propTypes = {
  id: string.isRequired,
  technologyProps: shape({
    header: string.isRequired,
    content: string.isRequired
  }).isRequired
};

const Desktop = ({ id, technologyProps }) => (
  <div
    id={id}
    className={'panel d-flex align-items-center'}
    style={{ height: `${window.innerHeight}px` }}
  >
    <img
      src={clouds}
      alt={'Slider1'}
      className={'img-fluid d-none d-md-block'}
    />
    <Container
      fluid={true}
      className={'abs-container d-flex align-items-center'}
    >
      <Row className={'justify-content-center'}>
        <Col md={10} xs={12}>
          <Row>
            <Col md={6} xs={12}>
              <TextBox {...technologyProps} />
            </Col>
            <Col md={6} xs={12}>
              <Row
                className={
                  Css['technology-img-wrapper'] + ' asap-medium abs-content'
                }
              >
                <img
                  src={cockpitEmpty}
                  alt={'Technology'}
                  className={'img-fluid d-md-block'}
                />
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
);

Desktop.propTypes = propTypes;

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Safety/Technology/Desktop/Desktop.jsx